import { GRAPHQL_ERROR, NETWORK_ERROR, RESET_ERROR, NO_WSS_AUTH_ERROR } from '../constants/error';
export const graphqlError = error => {
    return {
        type: GRAPHQL_ERROR,
        payload: error
    };
};

export const networkError = error => {
    return {
        type: NETWORK_ERROR,
        payload: error
    };
};

export const resetNetworkError = () => {
    return {
        type: RESET_ERROR,
        payload: NETWORK_ERROR
    };
};

export const resetGraphqlError = () => {
    return {
        type: RESET_ERROR,
        payload: GRAPHQL_ERROR
    };
};

export const noWssAuthError = () => {
    return {
        type: NO_WSS_AUTH_ERROR
    }
}